import React, { useEffect, useState } from "react";
import CaSideNav from "../../../components/AdminComponents/CaSideNav";
import SecondaryNav2 from "../../../components/AdminComponents/SecondaryNav2";
import {
  CaAdminMenu,
  CaAdminSettingsMenu,
  SecondaryNavCaAdmin,
} from "../../../components/AdminComponents/MenuItems";
import { Table, Popconfirm, Spin, message, Pagination, Switch } from "antd";
import { DeleteTwoTone, SwapOutlined } from "@ant-design/icons";
import EditableImage from "../../../components/icons/EditIcon";
import AddLocation from "../../../components/AdminComponents/Modals/AddLocation";
import { useSelector } from "react-redux";
import Axios from "../../../api/Axios";
import EditLocations from "../../../components/AdminComponents/Modals/EditLocations";
import { getUpdateStatus } from "../../../components/AdminComponents/ViewUpdateIndex";
import {
  capitalizeWords,
  remainingViewportHeight,
} from "../../../components/icons/ApplicationColor";
import CommonTopDetails from "../../../components/AdminComponents/CommonTopDetails";
import { useLocation } from "react-router-dom";

const Locations = () => {
  const [visible, setVisible] = useState(false);
  const userInfo = useSelector((state) => state.user);
  const [loading, setLoading] = useState(true);
  //   const [modalData, setModalData] = useState({});
  const [itemsLength, setItemsLength] = useState();
  const [locationData, setLocationdData] = useState();
  const [messageApi, contextHolder] = message.useMessage();
  const [editData, setEditData] = useState();
  const [editVisible, setEditVisible] = useState(false);
  const [filterData, setFilterData] = useState({
    active: true,
    pageSize: 15,
    currentPage: 1,
    url: `/locationlist/${userInfo.data.organization.id}/`,
    search: "",
  });
  const { pageSize, currentPage, url, search, active } = filterData;
  const LoadLocations = async () => {
    let passUrl = url;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 1) {
        passUrl += `?page=${currentPage}&page_size=${pageSize}&search=${search}&status=${
          active ? "True" : "False"
        }`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `?page=${currentPage}&page_size=${pageSize}&status=${
        active ? "True" : "False"
      }`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await Axios.get(passUrl);
        //console.log(res.data.results);
        setItemsLength(res.data.count);
        setLocationdData(res.data.results);
        setLoading(false);
        // setDisplayTable(false);
      } catch (err) {
        if (err.response && err.response.status === 404) {
          setLoading(false);
        }
        //console.log(err);
      }
    }
  };
  const handleRowClick = (record) => {
    //console.log(record);
    setEditData(record);
    setEditVisible(true);
  };
  const handleEditCancel = () => {
    setEditVisible(false);
  };
  const showModal = () => {
    setVisible(true);
  };

  const updateAuth = getUpdateStatus(userInfo, 0, 5);
  const handleCancel = () => {
    setVisible(false);
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const handleDeletePer = async (record) => {
    try {
      await Axios.delete(`/location/${record?.id}/`, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      setFilterData((prevData) => ({
        ...prevData,
        search: "",
      }));
      LoadLocations();
      DeleteLocation("success");
    } catch (err) {
      //console.log(err, "error");
      DeleteLocation("error");
    }
  };
  const handleDelete = async (record) => {
    //console.log("coming here", record.id);
    const data = {
      status: false,
    };
    try {
      await Axios.put(`/location/${record?.id}/`, data, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      setFilterData((prevData) => ({
        ...prevData,
        search: "",
      }));
      LoadLocations();
      InactiveLocation("success", "Location has been Archived");
    } catch (err) {
      //console.log(err, "error");
      InactiveLocation("error", err?.response?.data?.detail);
    }
  };
  const UnarchiveLocation = async (record) => {
    //console.log("coming here", record.id);
    const data = {
      status: true,
    };
    try {
      await Axios.put(`/location/${record?.id}/`, data, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      setFilterData((prevData) => ({
        ...prevData,
        search: "",
      }));
      LoadLocations();
      InactiveLocation("success", "Location Unarchived");
    } catch (err) {
      //console.log(err, "error");
      InactiveLocation("error", "Location UnArchive Failed");
    }
  };

  const CreateSuccessfull = (props) => {
    messageApi.open({
      type: "success",
      content: `Loaction detail has been ${props}.`,
      duration: 5,
    });
    setLoading(true);
    LoadLocations();
    if (props === "created") {
      // handleReset();
    }
  };

  const CreateFailed = (props, err) => {
    const messageApi = message;

    const errorMessage = err?.response?.data?.detail?.non_field_errors?.[0];

    messageApi.open({
      type: "error",
      content: errorMessage || `Location detail has not been ${props}.`,
      duration: 5,
    });
  };
  const DeleteLocation = (props) => {
    messageApi.open({
      type: props,
      content: `Location ${
        props === "success" ? "Deleted" : "had not been Deleted"
      }.`,
      duration: 5,
    });
  };
  const InactiveLocation = (props, message) => {
    messageApi.open({
      type: props,
      content: message,
      duration: 5,
    });
  };
  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
    }));
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
  };
  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
  };
  useEffect(() => {
    LoadLocations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);
  const columns = [
    {
      title: "Location Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
    },
    {
      title: "Zip/Postal Code",
      dataIndex: "zipcode",
      key: "zipcode",
    },
    {
      title: "Country",
      dataIndex: "country",
      key: "country",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    ...(updateAuth
      ? [
          {
            title: capitalizeWords("ACTIONS"),
            key: "actions",
            width: 100,
            align: "center",
            render: (text, record) => {
              return active ? (
                <>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <EditableImage
                      handleRowClick={handleRowClick}
                      recordId={record}
                    />
                    <Popconfirm
                      title="Archive Location"
                      description=" "
                      onConfirm={() => handleDelete(record)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                      placement="left"
                    >
                      <DeleteTwoTone
                        style={{
                          cursor: "pointer",
                          fontSize: "1.8rem",
                          marginLeft: "0.9rem",
                        }}
                        // onClick={() => {
                        //   handleDelete(record);
                        // }}
                        title="delete"
                        twoToneColor="#eb2f96"
                      />
                    </Popconfirm>
                  </div>
                </>
              ) : (
                <>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Popconfirm
                      title="Unarchive Location"
                      description=" "
                      onConfirm={() => UnarchiveLocation(record)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                      placement="left"
                    >
                      <SwapOutlined
                        style={{
                          cursor: "pointer",
                          fontSize: "1.8rem",
                          marginLeft: "0.9rem",
                        }}
                        title="unarchive"
                      />
                    </Popconfirm>
                    <Popconfirm
                      title="Permanently Delete Location"
                      description=" "
                      onConfirm={() => handleDeletePer(record)}
                      // onCancel={cancel}
                      placement="left"
                      okText="Yes"
                      cancelText="No"
                    >
                      <DeleteTwoTone
                        style={{
                          cursor: "pointer",
                          fontSize: "1.8rem",
                          marginLeft: "0.9rem",
                        }}
                        title="delete"
                        twoToneColor="#eb2f96"
                      />
                    </Popconfirm>
                  </div>
                </>
              );
            },
          },
        ]
      : []),
  ];
  const handleSwitchChange = (checked) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: "",
      active: checked,
      currentPage: 1,
    }));
  };
  const location = useLocation();
  const isSettingsPage = location.pathname.includes("settings"); // true if 'settings' in URL
  return (
    <CaSideNav props={isSettingsPage ? CaAdminSettingsMenu : CaAdminMenu}>
      {contextHolder}
      {!isSettingsPage && <SecondaryNav2 menuItems={SecondaryNavCaAdmin} />}
      <CommonTopDetails
        title={active ? "Locations" : "Inactive Locations"}
        titleSuffix={`${itemsLength || 0} Location(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={updateAuth}
        // showModal={showModal}
        addButtonProps={{
          modalType: "PopUP",
          modalProps: showModal,
        }}
        marginPass={isSettingsPage ? "70px" : "15px"}
        customContent={
          <Switch
            style={{
              backgroundColor: active ? "#50C878" : "#FF0000",
              minWidth: "90px",
            }}
            checked={active}
            disabled={loading}
            onChange={handleSwitchChange}
            checkedChildren="ACTIVE"
            unCheckedChildren="INACTIVE"
          />
        }
      />

      <Spin spinning={loading}>
        <Table
          dataSource={locationData}
          columns={columns}
          size="small"
          rowKey="id"
          bordered
          className="table-container"
          pagination={false}
          style={{ margin: "1rem" }}
          scroll={{
            x: 1000,
            y: `${remainingViewportHeight(30)}px`,
          }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "1rem",
          }}
        >
          <Pagination
            size="small"
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            onChange={onPageChange}
            pageSizeOptions={["10", "15", "30", "50", "100"]}
            showQuickJumper
            current={currentPage}
            defaultPageSize={pageSize}
            total={itemsLength}
          />
        </div>
      </Spin>
      <AddLocation
        visible={visible}
        onCancel={handleCancel}
        CreateFailed={CreateFailed}
        CreateSuccessfull={CreateSuccessfull}
      />
      <EditLocations
        key={editData?.id}
        visible={editVisible}
        onCancel={handleEditCancel}
        CreateFailed={CreateFailed}
        CreateSuccessfull={CreateSuccessfull}
        data={editData}
      />
    </CaSideNav>
  );
};

export default Locations;
